module.exports = __webpack_public_path__ + "static/media/stripe.d629f004.svg";